<template>
  <v-container
    fluid
    :key="curkey"
    id="loginContainer"
    class="primary fill-height d-flex justify-center"
    :style="{
      minHeight: '580px',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '678px 561px',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
    }"
  >
    <!-- background: 'url(' + logobg + ')', -->
    <!-- style="
        padding: 64px 72px;
        width: 512px;
        top: 50%;
        margin-top: -305px;
        position: absolute;
      " -->
    <v-progress-circular
      v-if="!show"
      indeterminate
      color="white"
      size="20"
      width="1"
    ></v-progress-circular>

    <v-card
      elevation="24"
      width="480"
      height="auto"
      class="logo_module"
      rounded
      v-if="showDialog"
    >
      <v-card-title class="pa-0 pt-8">
        {{ $t("label_essweb_login_secondVertifyTitle") }}
      </v-card-title>
      <v-card-subtitle class="pa-0 pt-4">
        {{ $t("label_essweb_login_secondVertifySubTitle") }}
        <span class="text--primary">{{ account }}</span>
      </v-card-subtitle>
      <v-card-text class="pa-0" style="padding-top: 44px !important">
        <v-form ref="form2" lazy-validation dense>
          <v-row cols="12" class="ml-0 mr-0">
            <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pa-0">
              <v-text-field
                class="text-body-1 ma-0"
                maxlength="50"
                :placeholder="$t('label_essweb_login_emailCodeLabel')"
                color="primary"
                v-model="email_code"
                height="44"
                :rules="
                  $GetRules(
                    ['_Require_Rules'],
                    [$t('label_essweb_login_emailCodeLabel')]
                  )
                "
                hide-details
                required
                :aria-autocomplete="false"
                :autofocus="false"
              />
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pa-0 my-3">
              <v-btn
                v-if="second == 0"
                color="primary"
                class="text-capitalize"
                @click="reSendCode"
                rounded
                text
                >{{ $t("label_essweb_form_tools_reSendCodeBtnLabel") }}</v-btn
              >
              <span v-else>
                {{
                  $t("label_essweb_login_canResendCodeLabel", {
                    time: second + "s",
                  })
                }}
              </span>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex justify-end pb-8">
        <v-btn
          color="primary"
          class="text-capitalize px-12"
          @click="showDialog = false"
          rounded
          text
          >{{ $t("label_essweb_form_tools_backBtnLabel") }}</v-btn
        >
        <v-btn
          color="primary"
          class="text-capitalize px-12"
          :disabled="!email_code"
          :loading="isLoading2"
          @click="secondLogin"
          rounded
          >{{ $t("label_essweb_form_tools_submitBtnLabel") }}</v-btn
        >
      </v-card-actions>
    </v-card>
    <svg-icon
      :size="bgstyle"
      iconClass="left"
      class="left_bg"
      :style="{
        left: -bgstyle / 2 + 'px',
      }"
    />
    <svg-icon
      :size="bgstyle"
      iconClass="right"
      class="right_bg"
      :style="{
        right: -bgstyle / 2 + 'px',
      }"
    />

    <v-card
      elevation="24"
      class="logo_module"
      transition="scale-transition"
      rounded
      v-if="show && !showDialog"
    >
      <!-- style="padding: 64px 72px; width: 512px; top: 179px; position: absolute" -->
      <v-card-title
        class="d-flex justify-space-between pa-0 pt-8"
        style="flex-wrap: nowrap"
      >
        <svg-icon width="171px" height="58px" :iconClass="logo" />
        <!-- <v-spacer></v-spacer> -->
        <v-menu offset-y small max-height="300">
          <template v-slot:activator="{ on }">
            <v-sheet
              v-on="on"
              class="
                text-button
                ma-0
                pa-2
                mt-5
                text-capitalize
                d-flex
                align-center
                text--secondary
              "
            >
              <div class="px-1 text-truncate">
                {{ showLang }}
              </div>
              <v-spacer></v-spacer>
              <i class="material-icons-round">arrow_drop_down</i></v-sheet
            >
          </template>
          <v-list dense>
            <v-list-item
              v-for="(item, index) in companyLang"
              :key="index"
              @click="setLang(item['value'])"
            >
              <v-list-item-title>{{ item["text"] }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-card-text class="pa-0" style="padding-top: 44px !important">
        <v-form ref="form" lazy-validation dense>
          <v-row cols="12" class="ml-0 mr-0">
            <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pa-0">
              <v-text-field
                class="text-body-1 ma-0"
                maxlength="50"
                :placeholder="
                  $t('label_essweb_login_accountNameLabel') +
                  ' / ' +
                  $t('label_essweb_login_mailLabel')
                "
                color="primary"
                v-model="account"
                height="44"
                :rules="
                  $GetRules(
                    ['_Require_Rules'],
                    [
                      $t('label_essweb_login_accountNameLabel') +
                        ' / ' +
                        $t('label_essweb_login_mailLabel'),
                    ]
                  )
                "
                required
                :aria-autocomplete="false"
                :autofocus="false"
              >
                <!-- 2020-11-19  -->
                <!-- <template v-slot:append v-if="account">
                  <v-icon @click="account = ''" class="mt-2"
                    >mdi-close-circle-outline</v-icon
                  >
                </template> -->
              </v-text-field>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pa-0 pb-2">
              <v-text-field
                class="text-body-1 ma-0"
                color="primary"
                :placeholder="$t('label_essweb_login_passwordLabel')"
                v-model="password"
                height="44"
                maxlength="50"
                :style="{
                  font:
                    passType === 'password' ? 'caption !important' : 'inherit',
                }"
                :type="passType"
                :rules="
                  $GetRules(
                    ['_Require_Rules', '_Length_Rules'],
                    [$t('label_essweb_login_passwordLabel'), 30]
                  )
                "
                required
              >
                <template v-slot:append>
                  <!-- font:caption !important 使用系统字体作为基础字体样式-->
                  <!-- 2020-11-19 -->
                  <!-- <v-icon
                    @click="password = ''"
                    class="mt-2 mr-1"
                    v-if="password"
                    >mdi-close-circle-outline</v-icon
                  > -->
                  <v-icon
                    class="mt-2"
                    @click="
                      passType == 'text'
                        ? (passType = 'password')
                        : (passType = 'text')
                    "
                    >{{ passIcon }}</v-icon
                  >
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              class="pa-0"
              style="padding-bottom: 32px !important"
            >
              <v-checkbox
                v-model="remember"
                class="mt-0 pa-0"
                color="primary"
                height="20"
                hide-details
                :label="$t('label_essweb_login_rememberMeLabel')"
                required
              >
                <template v-slot:label>
                  <span class="text-sm-caption text-body-2">{{
                    $t("label_essweb_login_rememberMeLabel")
                  }}</span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0 text-center pb-6">
              <v-btn
                rounded
                large
                :loading="isLoading"
                color="primary"
                style="
                  width: 50%;
                  min-width: 256px;
                  height: 48px;
                  letter-spacing: 0.0125em !important;
                "
                @click="toLogin"
                class="text-capitalize text-button white--text"
                >{{ $t("label_essweb_login_loginBtnLabel") }}</v-btn
              >
            </v-col>
            <v-col class="align-items-end text-center pa-0" cols="12">
              <v-btn
                text
                depressed
                height="20"
                tile
                @click="forgetPassword"
                :retain-focus-on-click="true"
                class="text-capitalize text--secondary text-button px-0"
              >
                {{ $t("label_essweb_login_forgetPasswordLabel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-sheet
      class="text-center footer-container max-width transparent"
      v-if="show"
    >
      <Footer
        fontColor="rgba(255, 255, 255, 0.68)"
        contentClass="pa-0 ma-0 pt-2"
        linkReverse
        center
      />
    </v-sheet>
    <v-snackbar
      v-model="MsgStatus.show"
      bootom
      class="animated slideInUp"
      :color="MsgStatus.color"
      :timeout="3000"
      @input="MsgStatus.show = false"
    >
      {{ MsgStatus.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon @click.stop="MsgStatus.show = false" v-bind="attrs">
          <span class="material-icons-round">highlight_off</span>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import Footer from "@/Layout/components/Footer";
import getBase from "@/util/mrc_base_init"; //高级参数获取
import logobg from "@/assets/BG_Blue.png";
export default {
  name: "Login",
  components: { Footer },
  computed: {
    ...mapGetters([
      "userInfo",

      "allLangLabel",
      "defaultLang",
      "showLang",
      "curBaseKey",
      "companyLang",
      "loginEncryptKey",
    ]),
    curLang() {
      return this.defaultLang
        ? this.defaultLang
        : this.$store.dispatch("setDefaultLang", "en");
    },
    logo() {
      return process.env.NODE_ENV == "production"
        ? "logoV1_ESS_full_e_blue"
        : "logoV1_ESS_full_e_blue_test";
    },

    bgstyle() {
      let size = 0;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          size = 0;
          break;
        case "sm":
          size = 600;
          break;
        case "md":
          size = 900;

          break;
        case "lg":
          size = 1000;

        case "xl":
          size = 1200;

          break;
        default:
          break;
      }
      return size;
    },
  },
  data() {
    return {
      showDialog: false,
      // curYear: 2020,
      logobg: logobg,
      show: false,
      curkey: 123,
      isLoading: false,
      isLoading2: false,
      valid: false,
      remember: true,
      account: "",
      second: 60,
      inter: null,
      email: "",
      email_code: "",
      passType: "password",
      passIcon: "mdi-eye-off",
      MsgStatus: {
        show: false,
        color: "",
        text: "",
      },
      password: "",
    };
  },
  watch: {
    allLangLabel(val, old) {
      const that = this;
      if (val && val != [] && !that.show) {
        this.$Sleep(500).then(() => {
          that.show = true;
          that.curkey = Math.random() * 1000000;
        });
      }
    },
    passType(val) {
      if (val == "password") {
        this.passIcon = "mdi-eye-off";
      } else {
        this.passIcon = "mdi-eye";
      }
    },
    email_code(val, old) {},
    showDialog(val) {
      const that = this;
      if (val) {
        if (this.inter) {
        } else {
          that.second = 60;
          that.email_code = "";
          this.inter = setInterval(() => {
            that.second--;
            if (that.second == 0) {
              clearInterval(that.inter);
            }
          }, 1000);
        }
      }
    },
  },
  async mounted() {
    // 更新年份
    // this.curYear =
    //   this.curYear +
    //   (dayjs(new Date())
    //     .format("YYYY")
    //     .toString() == this.curYear.toString()
    //     ? ""
    //     : " - " +
    //       dayjs(new Date())
    //         .format("YYYY")
    //         .toString());
    // // 获取浏览器语言
    // let lang = navigator.language || navigator.userLanguage;
    // let curLang = this.companyLang.find((ele) => ele.value == lang);
    // if (!curLang && this.companyLang.length) {
    //   this.setLang(this.companyLang[0]["value"]);
    // }

    const that = this;
    if (this.userInfo && this.userInfo !== "0" && this.userInfo !== 0) {
      this.account = JSON.parse(this.$aesDecrypt(that.userInfo)).mrc_account;
      this.password = JSON.parse(this.$aesDecrypt(that.userInfo)).mrc_password;
    }

    //监听登录页面enter
    document.onkeydown = function (e) {
      var theEvent = e || window.event;
      var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      if (code == 13) {
        e.preventDefault();
        that.toLogin();
        return false;
      }
      return true;
    };
    // 进入登录页面获取所有的label
    await this.$store.dispatch("setCompanyLang").then((e) => {
      this.$store
        .dispatch("SET_ALLLANGLABEL")
        .then((e) => {
          const langs = Object.keys(this.allLangLabel);
          const values = Object.values(this.allLangLabel);
          langs.forEach((item, index) => {
            if (item != "code" || item != "status" || item != "msg")
              this.$i18n.mergeLocaleMessage(item, values[index]);
          });
        })
        .catch((err) => {
          console.log(err);
          // 以key展示
          that.show = true;
        });
    });
  },
  async created() {
    await this.$store.dispatch("getLoginEncryptKey");
    this.$Sleep(500).then(() => {
      if (this.allLangLabel != []) this.show = true;
    });
  },
  destroyed() {
    document.onkeydown = undefined; //解绑
  },
  methods: {
    ...mapMutations(["SET_DEFAULTLANG"]),
    setLang: function (val) {
      if (this.defaultLang == val) {
        return;
      }
      this.SET_DEFAULTLANG(val);
      // this.$store.dispatch("setDefaultLang", val)
    },
    forgetPassword() {
      let url = "";
      if (window.location.href.indexOf("?") > 0) {
        url = window.location.href.slice(0, window.location.href.indexOf("?"));
      } else {
        url = window.location.href;
      }
      this.$toPage("/forget_password/" + this.$aesEncrypt(url), {});
    },
    reSendCode() {
      const that = this;
      this.isLoading2 = true;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_users",
        url: "/base/auth/send-auth/",
        data: {
          user_account: this.$loginEncrypt({
            msg: this.account,
            key: this.loginEncryptKey,
          }),
        },
        type: "lang",
      })
        .then((res) => {
          that.second = 60;
          that.email_code = "";
          that.inter = setInterval(() => {
            that.second--;
            if (that.second == 0) {
              clearInterval(that.inter);
            }
          }, 1000);
          that.isLoading2 = false;
          that.$showMessage({
            title: that.$t("message_essweb_form_textField_noticeTitle"),
            text: that.$t("message_mrc_ess_user_login_page_plsEmailCodeLabel"),
            type: "warning",
          });
        })
        .catch((err) => {
          that.isLoading2 = false;
        });
    },
    secondLogin: function () {
      const that = this;
      this.isLoading2 = true;
      if (!this.$refs["form2"].validate() && this.email_code.trim() == "") {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          text: this.$t(
            "label_mrc_ess_login_page_email_code_label_error_empty"
          ),
          type: "warning",
        });
        this.isLoading2 = false;
        return false;
      }
      this.$Request({
        method: "POST",
        table: "mrbase_sys_users",
        url: "/base/auth/login-auth/",
        data: {
          user_account: this.$loginEncrypt({
            msg: this.account,
            key: this.loginEncryptKey,
          }),
          auth_code: this.email_code,
        },
        type: "lang",
      })
        .then(async (res) => {
          that.loginSuccess(res, true).then((e) => {
            console.clear(); //清空控制台
            that.$toPage("/", {}, "replace");
          });
        })
        .catch((err) => {
          that.isLoading2 = false;
        });
    },
    toLogin: function () {
      const that = this;
      this.isLoading = true;
      if (
        !this.$refs["form"].validate() &&
        this.account.trim() == "" &&
        !this.$refs["form"].validate() &&
        this.password.trim() == ""
      ) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          text: this.$t(
            "label_mrc_ess_user_login_page_account_password_label_error_empty"
          ),
          type: "warning",
        });
        this.isLoading = false;

        return false;
      }
      if (!this.$refs["form"].validate() && this.account.trim() == "") {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          text: this.$t(
            "label_mrc_ess_user_forget_password_page_account_label_error_empty"
          ),
          type: "warning",
        });
        this.isLoading = false;

        return false;
      }
      if (!this.$refs["form"].validate() && this.password.trim() == "") {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          text: this.$t(
            "label_mrc_ess_user_change_password_page_original_password_label_error_empty"
          ),
          type: "warning",
        });
        this.isLoading = false;

        return false;
      }
      this.$Request({
        method: "POST",
        table: "mrbase_sys_users",
        url: "/login/",
        data: {
          user_account: this.$loginEncrypt({
            msg: this.account,
            key: this.loginEncryptKey,
          }),
          user_pwd: this.$loginEncrypt({
            msg: this.password,
            key: this.loginEncryptKey,
          }),
          timestamp: new Date().valueOf(),
        },
        notUser: true, //不需要token
      })
        .then(async (res) => {
          if (res.code == 200 && res.status == "success") {
            if (that.remember) {
              that.$store.dispatch(
                "setUserInfo",
                //帳號密碼加密
                this.$aesEncrypt(
                  JSON.stringify({
                    mrc_account: that.account,
                    mrc_password: that.password,
                  })
                )
              );
            } else {
              // 删除掉之前保存的密码
              that.$store.dispatch("setUserInfo", "");
            }
            that.loginSuccess(res).then((result) => {
              if (result) {
                console.clear(); //清空控制台
                that.$toPage("/", {}, "replace");
              } else {
                that.$showMessage({
                  title: that.$t("message_essweb_form_textField_noticeTitle"),
                  text: that.$t(
                    "message_mrc_ess_user_login_page_plsEmailCodeLabel"
                  ),
                  type: "warning",
                });
                that.email_code = "";
                that.isLoading = false;
                that.email = that.account;
                that.showDialog = true;
              }
            });
          } else {
            that.isLoading = false;
          }
        })
        .catch((err) => {
          that.isLoading = false;
        });
    },
    loginSuccess(res, authed) {
      const that = this;
      return new Promise((resolve, reject) => {
        that.$store.dispatch("setToken", res.data.token).then((e) => {
          if (authed) resolve(true);
          else
            that.$store
              .dispatch("setAppInfo", JSON.stringify(res.data))
              .then((e) => {
                if (res.data["is_enable_auth"] === true) {
                  // 需要二次验证
                  resolve(false);
                }
                // 获取公司所有语言的label
                else
                  that.$store.dispatch("setCompanyLang").then((e) => {
                    // 获取所属公司的可选语言
                    that.$store.dispatch("SET_ALLLANGLABEL").then((e) => {
                      const companyLang = that.$store.state.companyLang;
                      const is_default = companyLang.filter(
                        (item) => item.value == that.defaultLang
                      );
                      const currentCompanyDefaultLanguage = companyLang.filter(
                        (item) => item.is_default == 1
                      );
                      // 登录页选择的语言在用户语言种类里面，那就用登录选择的语言，反之，使用用户默认的语言
                      is_default.length > 0
                        ? that.SET_DEFAULTLANG(is_default[0].value)
                        : that.SET_DEFAULTLANG(
                            currentCompanyDefaultLanguage[0].value
                          );

                      const langs = Object.keys(that.allLangLabel);
                      const values = Object.values(that.allLangLabel);

                      langs.forEach((item, index) => {
                        if (item != "code" || item != "status" || item != "msg")
                          that.$i18n.mergeLocaleMessage(item, values[index]);
                      });
                      getBase(res.data.token, true); //基础数据获取
                      that.$store.dispatch("setNavKey", that.curBaseKey);
                      resolve(true);
                    });
                  });
              });
        });
      });
    },
  },
};
</script>
<style scoped>
.logo_module {
  width: 480px;
  height: 480px;
  padding: 0px 48px;
  position: absolute;
  top: 50%;
  z-index: 20;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 375px) {
  .logo_module {
    /* width: 341px; */
    width: 343px;
  }
  .lang_name {
    width: 64px;
  }
  .btn {
    width: 80px !important;
  }
}
.footer-container {
  position: absolute;
  z-index: 0;
  bottom: 0;
}
.left_bg {
  position: absolute;
  bottom: 0;
  -webkit-animation: rotate 20s ease-in-out infinite;
  -moz-animation: rotate 20s ease-in-out infinite;
  -o-animation: rotate 20s ease-in-out infinite;
  animation: rotate 20s ease-in-out infinite;
}
.right_bg {
  position: absolute;
  top: 0;
  -webkit-animation: rotate 20s ease-in-out infinite;
  -moz-animation: rotate 20s ease-in-out infinite;
  -o-animation: rotate 20s ease-in-out infinite;
  animation: rotate 20s ease-in-out infinite;
}
/* 旋转 */
@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(1.5);
    transform: rotate(180deg) scale(1.5);
  }
  100% {
    -webkit-transform: rotate(360deg) scale(1);
    transform: rotate(360deg) scale(1);
  }
}
@-moz-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(1.5);
    transform: rotate(180deg) scale(1.5);
  }
  100% {
    -webkit-transform: rotate(359deg) scale(1);
    transform: rotate(359deg) scale(1);
  }
}
@-o-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(1.5);
    transform: rotate(180deg) scale(1.5);
  }
  100% {
    -webkit-transform: rotate(359deg) scale(1);
    transform: rotate(359deg) scale(1);
  }
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(1.5);
    transform: rotate(180deg) scale(1.5);
  }
  100% {
    -webkit-transform: rotate(359deg) scale(1);
    transform: rotate(359deg) scale(1);
  }
}
</style>
